import { NotifyHelper } from "../../../helpers/toast";
import { eCaThiActionsObj } from "../../action-types/tct/ICaThiActions";
import { generateActionForKey, generateActions } from "../generateActions";

export const caThiActions = {
    ...generateActions(eCaThiActionsObj, "CA_THI"),
    ...generateActionForKey(eCaThiActionsObj, "CA_THI", "SAVE_SUCCESS", () => NotifyHelper.Success("Thành công")),
    ...generateActionForKey(eCaThiActionsObj, "CA_THI", "DELETE_SUCCESS", () => NotifyHelper.Success("Thành công")),
    ...generateActionForKey(eCaThiActionsObj, "CA_THI", "SAVE_ERROR", (m) => NotifyHelper.Error(m)),
    ...generateActionForKey(eCaThiActionsObj, "CA_THI", "DELETE_ERROR", (m) => NotifyHelper.Error(m)),
};
